const learnResetSubscribers = new Set<() => void>();

/**
 * Module-scoped subscriber set used to reset the Learn tab's Stack back to its summary screen from
 * outside the layout — currently the "Reset onboarding" action. The Learn tab preserves whatever
 * lesson route was open (the lesson `router.replace`s summary out of the stack), so wiping the
 * onboarding data alone wouldn't move the user off a stale lesson. The subscriber (see
 * `use-learn-stack-reset.ts`) re-creates summary, where the live `userSlide`-keyed query
 * re-resolves to the first intro slide — deferred until the Learn tab is active so it never steals
 * focus from the tab the reset was triggered on.
 */
export function subscribeLearnReset(subscriber: () => void) {
  learnResetSubscribers.add(subscriber);
  return () => {
    learnResetSubscribers.delete(subscriber);
  };
}

export function requestLearnReset(): void {
  for (const subscriber of learnResetSubscribers) {
    subscriber();
  }
}
